import { Injectable } from '@angular/core';
import { CostRateEntryModel } from '../../../../../../../core/models/user/cost-rate-entry.model';
import { assert } from '../../../../../../../core/assert/assert';
import { DateTimeHelper } from '../../../../../../../features/calendar/util/date-time-helper';

@Injectable({
  providedIn: 'root',
})
export class CostRateEntryService {
  public createCostEntry(
    costRateValue: number,
    startingFrom: Date | null,
    userId: number,
  ): CostRateEntryModel {
    const costEntry = new CostRateEntryModel();
    costEntry.startingFrom = startingFrom;
    costEntry.rate = costRateValue;
    costEntry.userId = userId;
    return costEntry;
  }

  /**
   * Add newCostRateEntry to the list of cost rate entries. If the new cost rate entry is before an existing cost rate entry, then
   * all subsequent cost rate entries will be deleted.
   */
  public alignCostRateEntriesByDateFrom(
    costRateEntry: CostRateEntryModel,
    costRateEntries: readonly CostRateEntryModel[],
  ): CostRateEntryModel[] {
    assert(costRateEntry.startingFrom !== null);
    assert(costRateEntries.length > 0);

    const updatedEntries: CostRateEntryModel[] = [];
    for (const entry of costRateEntries) {
      const differenceInDays = DateTimeHelper.differenceInDays(
        entry.startingFrom,
        costRateEntry.startingFrom,
      );
      if (differenceInDays >= 0) {
        break;
      } else {
        updatedEntries.push(entry);
      }
    }
    updatedEntries.push(costRateEntry);

    return updatedEntries;
  }
}
